import useBreakpoints from "@/hooks/useBreakpoints";

const LG_BREAKPOINT = 1024;

export const useIsMobileViewport = () => {
  const { mobile } = useBreakpoints({
    mobile: (width) => width < LG_BREAKPOINT,
  });
  return mobile;
};
